import { Navigation, Pagination, Swiper } from 'swiper';

$(function () {
  new Swiper('#news-slider', {
    modules: [Navigation, Pagination],
    navigation: {
      nextEl: '.news-button-next',
      prevEl: '.news-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 800,
    grabCursor: true,
  });

  new Swiper('#industries-slider', {
    modules: [Navigation],
    navigation: {
      nextEl: '.industries-button-next',
      prevEl: '.industries-button-prev',
    },
    slidesPerView: 1.5,
    spaceBetween: 20,
    speed: 500,
    grabCursor: true,
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 5,
      },
    },
  });

  const $sliderTabLinks = $('#industry-features-tabs .tab--item');
  let activeItem = '';

  if ($sliderTabLinks.length > 0) {
    activeItem = $sliderTabLinks.children().eq(0);

    activeItem.addClass('active');

    // Slides to each item click
    $sliderTabLinks.each(function () {
      $(this).on('click', function () {
        industrySlider.slideTo($sliderTabLinks.index($(this)));
      });
    });
  }

  const industrySlider = new Swiper('#industry-features-slider', {
    modules: [Navigation, Pagination],
    navigation: {
      nextEl: '.news-button-next',
      prevEl: '.news-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 800,
    grabCursor: true,
  });

  // Changes active index on slideChange event
  industrySlider.on('slideChange', function (slide) {
    activeItem.removeClass('active');

    activeItem = $sliderTabLinks.children().eq(slide.activeIndex);

    activeItem.addClass('active');
  });

});
